<mat-dialog-content>
  <div class="modal-content">
    <div class="modal-body p-0">
      <div class="col-12 pb-3 text-center">
        @if (mensaje() == 'Q') {
          <p class="mb-0">{{ 'mensaje.qualification' | translate }}</p>
        }

        @if (mensaje() == 'V') {
          <p class="mb-0">{{ 'mensaje.valuation' | translate }}</p>
        }
      </div>
      <div class="col-12 d-flex">
        <button class="dark-blue fw-normal d-inline m-auto" (click)="close(true)">
          {{ 'button.aceptar' | translate }}
        </button>
        <div class="mx-2 d-inline"></div>
        <button class="dark-blue-border d-inline m-auto" (click)="close(false)">
          {{ 'button.cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
</mat-dialog-content>
